module.exports = __webpack_public_path__ + "static/img/shopify.29d4910.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopify.svg
// module id = dzt2
// module chunks = 1